import React, { useEffect } from 'react';
import { SMART_APPOINTMENT } from '@/constants/smartAppointment';
import Spinner from '@/components/spinner';
import FormTemplate, { THEMES } from '@/components/formTemplate';
import DateSelector from '@/components/dateSelectorController';
import Text, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';

const { TITLE, ID, CALENDAR } = SMART_APPOINTMENT;

function SmartAppointment({
  control,
  firstAvailableAppointment = null,
  appointmentOptions = null,
  showTitle = true,
  step = null,
  info = null,
  loading,
  unregister,
  title = TITLE,
}) {
  useEffect(() => {
    if (!firstAvailableAppointment) {
      unregister(CALENDAR.ID);
    }
  }, [appointmentOptions]);

  return (
    <div className="smart-appointment-container">
      {(loading || firstAvailableAppointment || info) && (
        <FormTemplate
          titleText={showTitle ? title || TITLE : ''}
          cyData={ID}
          step={step}
          theme={THEMES.LONG}
        >
          {loading && (
            <div className="smart-appointment-container__spinner-container">
              <div className="smart-appointment-container__spinner">
                <Spinner size={30} />
              </div>
              <Text
                text="Calculando primera fecha disponible"
                color={TEXT_COLOR.GREY6}
                kind={TEXT_KIND.SPAN}
                size={TEXT_SIZE.CAPTION2}
                display={TEXT_DISPLAY.INLINE}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
            </div>
          )}
          {info && (
            <Text
              text={info}
              color={TEXT_COLOR.GREY5}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
          )}
          {!loading && firstAvailableAppointment && (
            <DateSelector
              control={control}
              id={CALENDAR.ID}
              name={CALENDAR.NAME}
              label={CALENDAR.LABEL}
              defaultValue={firstAvailableAppointment}
            />
          )}
        </FormTemplate>
      )}
      <style jsx>
        {`
          .smart-appointment-container {
            margin-bottom: 12px;
            .smart-appointment-container__spinner-container {
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 12px;
              .smart-appointment-container__spinner {
                position: relative;
                width: 30px;
                height: 30px;
              }
            }
          }
        `}
      </style>
    </div>
  );
}
export default SmartAppointment;
